import { DEFAULT_ITEMS_PER_PAGE } from '../constants/common';

const VALID_REPORTING_LIST_TAB_KEYS = [0, 1, 2, 3];

export const normalizeReportingListTab = (tab) => {
  if (tab === null || tab === undefined || String(tab).trim() === '') {
    return null;
  }
  const parsed = parseInt(tab, 10);
  return VALID_REPORTING_LIST_TAB_KEYS.includes(parsed) ? parsed : null;
};

export const parseReportingListPage = (searchParams) => {
  const raw = typeof searchParams?.get === 'function'
    ? searchParams.get('listPage')
    : searchParams?.listPage;
  const listPage = parseInt(raw, 10);
  return listPage > 0 ? listPage : 1;
};

export const parseReportingListSize = (searchParams) => {
  const raw = typeof searchParams?.get === 'function'
    ? searchParams.get('size')
    : searchParams?.size;
  const size = parseInt(raw, 10);
  return size > 0 ? size : DEFAULT_ITEMS_PER_PAGE;
};

/**
 * Builds the reporting list route with optional standard view, status tab, and pagination.
 * Tab keys (page param): 1 Finalized, 0 Draft, 2 Not Started, 3 Failed.
 * listPage param: pagination page number (1-based).
 */
export const buildReportingListUrl = ({ view, page, listPage, size } = {}) => {
  const params = new URLSearchParams();
  if (view) {
    params.set('view', view);
  }
  const normalizedPage = normalizeReportingListTab(page);
  if (normalizedPage !== null) {
    params.set('page', String(normalizedPage));
  }
  const parsedListPage = parseInt(listPage, 10);
  if (parsedListPage > 1) {
    params.set('listPage', String(parsedListPage));
  }
  const parsedSize = parseInt(size, 10);
  if (parsedSize > 0 && parsedSize !== DEFAULT_ITEMS_PER_PAGE) {
    params.set('size', String(parsedSize));
  }
  const query = params.toString();
  return `/company_admin/reporting_list${query ? `?${query}` : ''}`;
};
